(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jnc-password"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jaron-countdown')) {
    class JaronCountdown extends HTMLElement {
      connectedCallback() {
        this.target = new Date(this.dataset.date).getTime();
        if (Number.isNaN(this.target)) {
          this.hidden = true;
          return;
        }

        const dateDisplay = this.parentElement?.querySelector('[data-launch-date-display]');
        if (dateDisplay && !dateDisplay.textContent.trim()) {
          dateDisplay.textContent = new Intl.DateTimeFormat('he-IL', {
            dateStyle: 'long',
            timeStyle: 'short',
            timeZone: 'Asia/Jerusalem'
          }).format(new Date(this.target));
        }

        this.days = this.querySelector('[data-days]');
        this.hours = this.querySelector('[data-hours]');
        this.minutes = this.querySelector('[data-minutes]');
        this.seconds = this.querySelector('[data-seconds]');
        this.update();
        this.timer = window.setInterval(() => this.update(), 1000);
      }

      disconnectedCallback() {
        window.clearInterval(this.timer);
      }

      update() {
        const remaining = this.target - Date.now();

        if (remaining <= 0) {
          window.clearInterval(this.timer);
          const finished = document.createElement('div');
          finished.className = 'jaron-password__countdown-finished';
          finished.textContent = this.dataset.expiredText || '';
          this.replaceChildren(finished);
          return;
        }

        const day = 1000 * 60 * 60 * 24;
        const hour = 1000 * 60 * 60;
        const minute = 1000 * 60;

        this.days.textContent = String(Math.floor(remaining / day)).padStart(2, '0');
        this.hours.textContent = String(Math.floor((remaining % day) / hour)).padStart(2, '0');
        this.minutes.textContent = String(Math.floor((remaining % hour) / minute)).padStart(2, '0');
        this.seconds.textContent = String(Math.floor((remaining % minute) / 1000)).padStart(2, '0');
      }
    }

    customElements.define('jaron-countdown', JaronCountdown);
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
